import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import '../../../assets/custom/css/add.css';
import { Column } from "primereact/column";
import { API_REMARK_LIST } from "../../../service/url";
import { getApiCall } from "../../../service/httpCall";
import '@fortawesome/fontawesome-free/css/all.min.css';

const CallHistory = () => {
  const [remarkList, setRemarkList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [activeCall, setActiveCall] = useState(null);

  useEffect(() => {
    const dummyData = Array.from({ length: 10 }).map((_, i) => ({
      id: i + 1,
      mobile_number: `98765432${i}${i}`,
      agentId: { username: `Agent ${i + 1}` },
      remark: [`Customer feedback ${i + 1}`],
      created_at: new Date(Date.now() - i * 3600000),
    }));

    const formatted = dummyData.map((item) => ({
      ...item,
      createdAtFormatted: new Date(item.created_at).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    }));
    setRemarkList(formatted);
  }, []);


const handleViewRemark = (row) => {
  setSelectedRemark(row.remark);
  setShowModal(true);
};
  useEffect(() => {
    getApiCall(API_REMARK_LIST, {})
      .then(onSuccess)
      .catch(console.log);
  }, []);

  const handleCallClick = (rowData) => {
    setActiveCall(rowData);
  };

  const handleHangUp = () => {
    setActiveCall(null);
  };

  const onSuccess = (resp) => {
    const formatted = resp.map((item) => ({
      ...item,
      createdAtFormatted: new Date(item.created_at).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    }));
    // setRemarkList(formatted);
  };

  // const phoneTimeTemplate = (rowData) => (
  //   <div className="remark-item">
  //     <div className="remark-avatar"><i className="fa fa-user" /></div>
  //     <div className="remark-info">
  //       <div className="remark-phone">{rowData.mobile_number}</div>
  //       <div className="remark-time">{rowData.createdAtFormatted}</div>
  //     </div>
  //     <div className="remark-call"><i className="fa fa-phone" /></div>
  //   </div>
  // );

  const phoneTimeTemplate = (rowData) => (
    <div className="remark-item" style={{ display: "flex", alignItems: "center" }}>
      <div
        className="remark-avatar"
        onClick={() => handleCallClick(rowData)}
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#ffffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "8px",
          border: "2px solid green",
          cursor: "pointer"
        }}
      >
        <i className="fa fa-phone" style={{ rotate: "90deg", fontSize: "12px", color: "green" }} />
      </div>
      <div className="remark-info" style={{ flexGrow: 1 }}>
        <div className="remark-phone" style={{ fontWeight: "bold" }}>
          {rowData.mobile_number}
        </div>
        <div className="remark-time" style={{ fontSize: "12px", color: "#666" }}>
          {rowData.createdAtFormatted}
        </div>
      </div>
    </div>
  );

  return (
    <div className="card" style={{ height: '480px', overflow: 'hidden'}}>
    <div className="card-body" style={{ padding: '0.10rem' }}>
      {!activeCall ?
      <div style={{ maxHeight: '480px', overflowY: 'auto' }}>
       <DataTable value={remarkList} rows={7} paginator className="p-datatable-sm">
  <Column
    header="Contact Info"
    body={phoneTimeTemplate}
    style={{ width: '5%', padding: '4px' }}
  />
  <Column
  field="agentId.username"
  header="Agent Name"
  style={{ width: '20%', padding: '4px' }}
  headerStyle={{ textAlign: 'left', paddingLeft: '-11px' }}
/>
<Column
  header="Remarks"
  body={(rowData) => (
    <i
      className="fa fa-eye"
      style={{ cursor: 'pointer', color: '#007bff' }}
      onClick={() => handleViewRemark(rowData)}
    />
  )}
  style={{ width: '10%', textAlign: 'center' }}
/>
</DataTable>

{showModal && (
  <div className="custom-modal-overlay">
    <div className="custom-modal-content" >
      <div className="modal-header bg-success text-white" style={{marginTop:"-16px", marginLeft:"-16px", marginRight:"-16px", padding: "10px"}}>
        <h5 className="m-0">Remarks</h5>
        <span className="modal-close text-white" onClick={() => setShowModal(false)} style={{ top: "3px" }}>×</span>
      </div>
      <ul className="mt-3">
        {Array.isArray(selectedRemark) ? (
          selectedRemark.map((r, index) => <li key={index}>{r}</li>)
        ) : (
          <li>{selectedRemark}</li>
        )}
      </ul>
    </div>
  </div>
)}

      </div> : <div
            style={{
              height: "460px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              background: "rgb(8, 29, 93)",
              borderRadius: "10px",
              color: "white",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "20px",
                textAlign: "center",
                width: "100%",
              }}
            >
              <h4 style={{ margin: "0", fontWeight: "600" }}>
                {activeCall.agentId.username}
              </h4>
              <p style={{ margin: "4px 0 0", opacity: "0.8" }}>
                {activeCall.mobile_number}
              </p>
            </div>

            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                backgroundColor: "rgba(0, 33, 165, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 20px rgba(255,255,255,0.2)",
              }}
            >
              <i className="fa fa-user" style={{ fontSize: "60px", color: "white" }} />
            </div>

            <div style={{ position: "absolute", bottom: "40px" }}>
              <button
                onClick={handleHangUp}
                style={{
                  backgroundColor: "red",
                  border: "none",
                  borderRadius: "50%",
                  width: "70px",
                  height: "70px",
                  color: "white",
                  fontSize: "28px",
                  cursor: "pointer",
                  boxShadow: "0 0 15px rgba(255,0,0,0.6)",
                }}
              >
                <i className="fa fa-phone" style={{ transform: "rotate(-135deg)" }} />
              </button>
            </div>
          </div>}
    </div>
  </div>
  );
};

export default CallHistory;
